import "core-js/modules/es6.regexp.to-string";
import _toConsumableArray from "D:/zlwl/portal/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import "core-js/modules/web.dom.iterable";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/zlwl/portal/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { listConfig, updateConfig } from "@/api/configurationlist";
export default {
  data: function data() {
    var validateslaveid = function validateslaveid(rule, value, callback) {
      if (value === '') {
        callback(new Error('请输入从站ID'));
      } else if (isNaN(value)) {
        callback(new Error('请输入1-255之间的数字'));
      } else if (value < 1 || value > 255) {
        callback(new Error('从站ID范围1-255'));
      } else {
        callback();
      }
    };

    var validatestart = function validatestart(rule, value, callback) {
      if (value === '') {
        callback(new Error('请输入起始地址'));
      } else if (isNaN(value)) {
        callback(new Error('请输入0-65535之间的数字'));
      } else if (value < 0 || value > 65535) {
        callback(new Error('起始地址范围0-65535'));
      } else {
        callback();
      }
    };

    var validateprecise = function validateprecise(rule, value, callback) {
      if (value === '') {
        callback(new Error('请输入精度'));
      } else if (isNaN(value)) {
        callback(new Error('精度范围1-6'));
      } else if (value < 0 || value > 65535) {
        callback(new Error('精度范围1-6'));
      } else {
        callback();
      }
    };

    var validatefactor = function validatefactor(rule, value, callback) {
      // 必须为正整数
      if (value === '') {
        callback(new Error('请输入计算因子'));
      } else if (isNaN(value)) {
        callback(new Error('计算因子必须为数字'));
      } else {
        callback();
      }
    };

    var validatesize = function validatesize(rule, value, callback) {
      if (value === '') {
        callback(new Error('请输入数据长度'));
      } else if (isNaN(value)) {
        callback(new Error('数据长度范围1-30'));
      } else if (value < 0 || value > 65535) {
        callback(new Error('数据长度范围1-30'));
      } else {
        callback();
      }
    };

    return {
      currentData: {
        name: '',
        dev_addr: '',
        start: '',
        datatype: 'bool',
        size: '',
        precise: '',
        factor: '',
        sname: undefined,
        index: undefined,
        bind_dev: false,
        endian: 'ABCD',
        rack: '0',
        area: 'DB',
        dbnum: '0',
        slot: '0'
      },
      ipList: [],
      dialogTitle: '编辑',
      formLoadng: false,
      rules: {
        name: [{
          required: true,
          message: '请输入名称',
          trigger: 'blur'
        }],
        start: [{
          validator: validatestart,
          trigger: 'blur'
        }],
        precise: [{
          validator: validateprecise,
          trigger: 'blur'
        }],
        size: [{
          validator: validatesize,
          trigger: 'blur'
        }],
        factor: [{
          validator: validatefactor,
          trigger: 'blur'
        }]
      },
      dialogVisible: false,
      byteList: [{
        label: 'ABCD',
        value: 'ABCD'
      }, {
        label: 'CDAB',
        value: 'CDAB'
      }, {
        label: 'DCBA',
        value: 'DCBA'
      }, {
        label: 'BADC',
        value: 'BADC'
      }],
      rackList: [],
      slotList: [],
      areaList: [{
        label: 'DB',
        value: 'DB'
      }, {
        label: 'Digital Inputs',
        value: 'Digital Inputs'
      }, {
        label: 'Digital Outputs',
        value: 'Digital Outputs'
      }, {
        label: 'Merkers',
        value: 'Merkers'
      }, {
        label: 'Timers',
        value: 'Timers'
      }, {
        label: 'Counters',
        value: 'Counters'
      }]
    };
  },
  props: ['deviceSn', 'deviceDid'],
  methods: {
    getDevIp: function () {
      var _getDevIp = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var _this = this;

        var resp, sml;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return listConfig(this.deviceSn, this.deviceDid, [{
                  "section": "conn",
                  config: "smartlink",
                  options: [{
                    option: 'mode'
                  }, {
                    option: 'dev_name'
                  }],
                  lists: [{
                    list: 'server'
                  }]
                }]);

              case 2:
                resp = _context.sent;

                if (resp.data.success) {
                  _context.next = 5;
                  break;
                }

                return _context.abrupt("return", this.$message.error('操作失败'));

              case 5:
                sml = resp.data.data.mess[0].s_objects;
                sml.forEach(function (item) {
                  if (item.options.mode === 'S7 Client') {
                    var _this$ipList;

                    // if (item.options.dev_name != '') {
                    //   this.ipList.push({
                    //     label: item.options.dev_name,
                    //     value: item.options.dev_name
                    //   })
                    // }
                    (_this$ipList = _this.ipList).push.apply(_this$ipList, _toConsumableArray(item.lists.server.map(function (e) {
                      return {
                        label: e,
                        value: e
                      };
                    })));
                  }
                });

              case 7:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getDevIp() {
        return _getDevIp.apply(this, arguments);
      }

      return getDevIp;
    }(),
    handleClose: function handleClose() {},
    confirmAdd: function confirmAdd() {
      this.$emit('update', this.currentData);
    }
  },
  mounted: function mounted() {
    for (var i = 0; i < 19; i++) {
      if (i < 4) {
        this.rackList.push({
          label: i.toString(),
          value: i.toString()
        });
      }

      this.slotList.push({
        label: i.toString(),
        value: i.toString()
      });
    }

    this.getDevIp();
  },
  computed: {
    dataTypeList: function dataTypeList() {
      return [{
        label: 'bool',
        value: 'bool'
      }, {
        label: 'int16',
        value: 'int16'
      }, {
        label: 'uint16',
        value: 'uint16'
      }, {
        label: 'int32',
        value: 'int32'
      }, {
        label: 'uint32',
        value: 'uint32'
      }, {
        label: 'int64',
        value: 'int64'
      }, {
        label: 'uint64',
        value: 'uint64'
      }, {
        label: 'float',
        value: 'float'
      }, {
        label: 'double',
        value: 'double'
      }, {
        label: 'string',
        value: 'string'
      }, {
        label: 'raw',
        value: 'raw'
      }];
    }
  }
};